export const DELIVERY_METHOD_CODES = {
  ON_ORDER: "1",
  TAKEWAY: "2",
  DELAYED_TAKEWAY: "3"
}
